import constants from './constants';

const initState = {
  alarmsList: null,
  offset: 0,
  limit: 40,
  count: null,
  createEditValues: null,
  search: '',
  isEditDefault: false,
  idsInDeleting: [],
};

function alarmsReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.SET_IS_EDIT_DEFAULT:
      return {
        ...state,
        isEditDefault: payload,
      };

    case constants.RESET_ALARMS:
      return {
        ...state,
        alarmsList: null,
        offset: 0,
        count: null,
      };

    case constants.SET_SEARCH:
      return {
        ...state,
        search: payload,
      };

    case constants.RESET_OFFSET:
      return {
        ...state,
        offset: 0,
        count: null,
      };

    case constants.SET_ALARMS_LIST:
      return {
        ...state,
        alarmsList: payload.alarmsList,
        offset: payload.offset,
        count: payload.count,
      };

    case constants.EDIT_ALARM:
      return {
        ...state,
        alarmsList: payload,
      };

    case constants.START_DELETING_ALARM:
      return {
        ...state,
        idsInDeleting: payload,
      };

    case constants.ADD_ALARM:
    case constants.DELETE_ALARM:
      return {
        ...state,
        alarmsList: payload.alarmsList,
        count: payload.count,
        idsInDeleting:
          payload.idsInDeleting !== undefined ? payload.idsInDeleting : state.idsInDeleting,
      };

    case constants.SET_ALARM_COUNT:
      return {
        ...state,
        count: payload,
      };

    case constants.SET_CREATE_EDIT_VALUES:
    case constants.ADD_CREATE_EDIT_VALUES_GROUP_CONDITIONS:
    case constants.REMOVE_CREATE_EDIT_VALUES_GROUP_CONDITIONS:
    case constants.ADD_CREATE_EDIT_VALUES_OR_CONDITION:
    case constants.REMOVE_CREATE_EDIT_VALUES_OR_CONDITION:
    case constants.CHANGE_CREATE_EDIT_VALUES_OR_CONDITION:
    case constants.ADD_CREATE_EDIT_VALUES_ACTION:
    case constants.REMOVE_CREATE_EDIT_VALUES_ACTION:
    case constants.CHANGE_CREATE_EDIT_VALUES_ACTION:
      return {
        ...state,
        createEditValues: payload,
      };

    default:
      return state;

  }

}

export default alarmsReducer;
